module.exports = __webpack_public_path__ + "img/32.d9ebb2e4.png";